/**

 * this is a flip animation for the cards in the specifications block
 * it handles states for the open and close animation and has prefers reduced motion support
 * improvements might be needed as this is the first time we have used FLIP in a project.
 * also worth noting, it adds to the js bundle a bit...
 */

import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';

gsap.registerPlugin(Flip);

const reducedMotionQuery = window.matchMedia
  ? window.matchMedia('(prefers-reduced-motion: reduce)')
  : null;

function initSpecificationsBlock(section) {
  const list = section.querySelector('.specifications-list');
  const toggles = section.querySelectorAll('.specs-toggle');
  let openItem = null;

  if (!list || !toggles.length) {
    return;
  }

  function setOpen(item, isOpen) {
    item.classList.toggle('open', isOpen);
    item
      .querySelector('.specs-toggle')
      .setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function toggleItem(item) {
    const wasOpen = item === openItem;

    const animate = !(reducedMotionQuery && reducedMotionQuery.matches);
    const state = animate
      ? Flip.getState(list.querySelectorAll('.specs-item, .specs-icon'))
      : null;

    if (openItem) {
      setOpen(openItem, false);
      openItem = null;
    }

    if (!wasOpen) {
      setOpen(item, true);
      openItem = item;
    }

    if (state) {
      Flip.from(state, {
        duration: 0.4,
        ease: 'power2.inOut',
        nested: true,
      });
    }
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      toggleItem(toggle.closest('.specs-item'));
    });
  });
}

document
  .querySelectorAll('section.specifications')
  .forEach(initSpecificationsBlock);